<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="任务号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入任务号查询" v-model="queryParam.taskNo"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.status" allowClear placeholder="请选择状态">
                    <a-select-option v-for="(name, status) in statusMap" :key="status" :value="status">
                      {{ name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="12" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" type="primary" icon="plus" @click="handleAdd">创建配送任务</a-button>
        </div>
        <section>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <template slot="status" slot-scope="text, record">
              <a-tag :color="statusColor[text]">{{ record.statusName || statusMap[text] || text }}</a-tag>
            </template>
            <template slot="routeMode" slot-scope="text, record">
              <span>{{ record.routeModeName || '-' }}</span>
              <div v-if="record.routeSummary" class="route-summary">{{ record.routeSummary }}</div>
            </template>
            <template slot="progress" slot-scope="text, record">
              {{ record.signedCount }}/{{ record.stopCount }}
            </template>
            <span slot="action" slot-scope="text, record">
              <a @click="handleDetail(record)">详情</a>
            </span>
          </a-table>
        </section>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />
        <delivery-task-create-modal ref="createModal" @ok="modalFormOk" />
        <delivery-task-detail-modal ref="detailModal" />
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import DeliveryTaskCreateModal from './DeliveryTaskCreateModal'
import DeliveryTaskDetailModal from './DeliveryTaskDetailModal'

export default {
  name: 'DeliveryTaskList',
  mixins: [JeecgListMixin],
  components: {
    DeliveryTaskCreateModal,
    DeliveryTaskDetailModal
  },
  data() {
    return {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 17,
        offset: 1
      },
      urlPath: '/plugin/order-receive/delivery',
      queryParam: {
        taskNo: '',
        status: undefined
      },
      statusMap: {
        '0': '待配送',
        '1': '配送中',
        '2': '已完成'
      },
      statusColor: {
        '0': 'orange',
        '1': 'blue',
        '2': 'green'
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '任务号',
          dataIndex: 'taskNo',
          width: 170
        },
        {
          title: '配送员',
          dataIndex: 'courierName',
          width: 120
        },
        {
          title: '配送进度',
          dataIndex: 'progress',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'progress' }
        },
        {
          title: '路线方案',
          dataIndex: 'routeMode',
          width: 200,
          scopedSlots: { customRender: 'routeMode' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/delivery-tasks'
      }
    }
  },
  methods: {
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        taskNo: this.queryParam.taskNo,
        status: this.queryParam.status
      }
    },
    handleAdd() {
      this.$refs.createModal.open()
    },
    handleDetail(record) {
      this.$refs.detailModal.open(record.id)
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
.route-summary {
  color: #888;
  font-size: 12px;
}
</style>
